import { DeliveryMethod } from '../models/Order';

const translateDevlieryMethod = (method: DeliveryMethod) => {
  switch (method) {
    case DeliveryMethod.KURIER_INPOST:
      return 'Kurier InPost';
    case DeliveryMethod.PACZKOMAT:
      return 'Paczkomaty InPost';
    default:
      return method;
  }
};

export default translateDevlieryMethod;
